

/* ============================================================================

   CARRITO DE VELANTIS  ·  listo para conectar a Shopify

   ----------------------------------------------------------------------------

   PARA CONECTARLO (lo hace quien integre la tienda):

   1) Pon el dominio de la tienda en SHOP.domain, p. ej. 'velantis.myshopify.com'

   2) Da de alta el ID de variante de cada perfume en SHOP.variants:

        { "BACCARAT ROUGE 540": "44012345678901", ... }

      (el ID de variante se ve en el admin de Shopify, en la URL del producto)

   Con eso, "Finalizar compra" manda al checkout real de Shopify usando el

   permalink oficial:  https://TIENDA/cart/ID:CANTIDAD,ID:CANTIDAD

   No hace falta ningún script externo.

   ============================================================================ */

window.SHOP = { domain: '', variants: {} };



(function(){

  var KEY='velantis-cart';

  var items=[];                                   // {name, price, img, qty}

  /* Lo que sale de localStorage se limpia AQUI, una sola vez. Ver el arreglo

     29 en arreglar.py: sin esto, un precio negativo dejaba el total en NaN y

     una cantidad de seis cifras congelaba la pestana. */

  function leerCarritoSeguro(){

    var crudo;

    try{ crudo = JSON.parse(localStorage.getItem(KEY)); }catch(e){ return []; }

    if(!Array.isArray(crudo)) return [];

    var limpio = [];

    for(var i = 0; i < crudo.length && limpio.length < 50; i++){

      var it = crudo[i];

      if(!it || typeof it !== 'object') continue;

      var nom = String(it.name == null ? '' : it.name).slice(0, 120);

      if(!nom) continue;

      limpio.push({

        name:  nom,

        sub:   String(it.sub == null ? '' : it.sub).slice(0, 120),

        img:   /^[a-z0-9 _-]{0,60}$/i.test(String(it.img || '')) ? String(it.img || '') : '',

        talla: String(it.talla) === '50' ? '50' : '100',

        price: Math.max(0, Math.min(100000, Number(it.price) || 0)),

        qty:   Math.max(1, Math.min(20, parseInt(it.qty, 10) || 1)), v: /^\d{6,20}$/.test(String(it.v || '')) ? String(it.v) : undefined /* VC-CEDE */

      });

    }

    return limpio;

  }

  items = leerCarritoSeguro();



  var ov=document.getElementById('cartOv'), list=document.getElementById('cartItems'),

      total=document.getElementById('cartTotal'), go=document.getElementById('cartGo'),

      note=document.getElementById('cartNote'), dot=document.querySelector('.cart-dot');



  function save(){ if(window.__VC_NUEVO) return; /* VC-CEDE */ try{ localStorage.setItem(KEY,JSON.stringify(items)); }catch(e){} }

  function count(){ return items.reduce(function(n,i){return n+i.qty;},0); }

  function sum(){ return items.reduce(function(n,i){return n+i.price*i.qty;},0); }

  function money(n){ return '$'+n.toLocaleString('es-MX')+' MXN'; }

  function esc(s){ return String(s).replace(/[&<>"]/g,function(c){

    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }



  function render(){ if(window.__VC_NUEVO){ if(window.__VC) window.__VC.recargar(); return; } /* VC-CEDE */

    if(dot){ dot.textContent=count(); dot.classList.add('pop');

      setTimeout(function(){dot.classList.remove('pop');},320); }

    if(!items.length){

      list.innerHTML='<p class="cart-empty">Tu carrito está vacío.</p>';

      total.textContent=money(0); go.disabled=true; note.textContent=''; save(); return;

    }

    go.disabled=false;

    list.innerHTML=items.map(function(it,i){

      return '<div class="ci">'+

        '<div class="ci-img '+esc(it.img)+'"></div>'+

        '<div><div class="ci-name">'+esc(it.name)+'</div>'+

          (it.sub?'<div class="ci-sub">'+esc(it.sub)+'</div>':'')+

          ((window.vPres&&window.vPres.tiene(it.name))?('<div class="ci-talla">'+['50','100'].map(function(tl){ return '<button type="button" data-t="'+i+':'+tl+'"'+(((it.talla||'100')===tl)?' class="on"':'')+'>'+tl+' ml</button>'; }).join('')+'</div>'):'')+

          /* EL REGALO NO SE MANEJA A MANO: lo pone la promocion, uno por cada dos

             perfumes. No debe poder subirse ni quitarse desde el carrito; se

             retira solo cuando se quitan los perfumes que lo destraban. */

          (it.price ? '<div class="ci-qty"><button data-m="'+i+'" aria-label="Quitar uno">−</button>'+

            '<span>'+esc(it.qty)+'</span>'+

            '<button data-p="'+i+'" aria-label="Agregar uno">+</button></div>' : '<div class="ci-promo">'+(window.VELANTIS_PAQUETE && it.name===window.VELANTIS_PAQUETE.obsequio ? 'Obsequio de la casa' : 'Regalo de tu promoci\u00f3n')+'</div>')+'</div>'+

        '<div class="ci-right"><div class="ci-price">'+money(it.price*it.qty)+'</div>'+

          '<button class="ci-del" data-d="'+i+'">Quitar</button></div></div>';

    }).join('');

    total.textContent=money(sum());

    save();

  }



  function add(item){ if(window.__VC_NUEVO && window.__VC) return window.__VC.add(item); /* VC-CEDE */
    /* 3-sep: el frasco de 30 ml no se vende; solo entra como regalo de una
       promocion, y ese renglon lo pone la propia promocion, no este boton.
       Cualquier intento de agregar talla 30 se ignora. */
    if(String(item && item.talla)==='30' || /-30$/.test(String(item && item.sku||''))) return;
    var tl=item.talla||'100';

    var f=items.filter(function(i){return i.name===item.name && (i.talla||'100')===tl;})[0];

    if(f) f.qty++; else items.push({name:item.name,price:item.price,img:item.img,sub:item.sub,qty:1,talla:tl});

    render(); open();

  }

  function open(){ if(window.__VC_NUEVO && window.__VC) return window.__VC.open(); /* VC-CEDE */ ov.classList.add('show'); document.body.style.overflow='hidden'; }

  function close(){ ov.classList.remove('show'); document.body.style.overflow=''; }



  list.addEventListener('click',function(e){

    var b=e.target.closest('button'); if(!b) return;

    var k0=+(b.dataset.p!=null?b.dataset.p:b.dataset.m!=null?b.dataset.m:b.dataset.d);

    if(items[k0] && !(+items[k0].price)) return;   /* el regalo, intocable */

    if(b.dataset.p!=null) items[+b.dataset.p].qty++;

    else if(b.dataset.m!=null){ var i=+b.dataset.m; if(--items[i].qty<=0) items.splice(i,1); }

    else if(b.dataset.d!=null) items.splice(+b.dataset.d,1);

    else if(b.dataset.t!=null){ var pt=b.dataset.t.split(':'), itx=items[+pt[0]];

      if(itx&&window.vPres){ itx.talla=pt[1]; var np=window.vPres.precio(itx.name,pt[1]); if(np!=null) itx.price=np; } }

    render();

  });

  document.getElementById('cartClose').addEventListener('click',close);

  ov.addEventListener('click',function(e){ if(e.target===ov) close(); });

  document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });



  // el icono del carrito abre el panel

  var icon=document.querySelector('.tools .icon-btn[aria-label="Carrito"]');

  if(icon) icon.addEventListener('click',open);



  /* --- Checkout: entrega el carrito a Shopify --- */

  go.addEventListener('click',function(){

    var faltan=items.filter(function(i){ return !SHOP.variants[i.name]; });

    if(!SHOP.domain || faltan.length){

      note.textContent='Checkout listo para conectar: falta el dominio de la tienda y el ID de variante de '+

        faltan.length+' producto(s). Ver instrucciones en el código.';

      return;

    }

    var partes=items.map(function(i){ return SHOP.variants[i.name]+':'+i.qty; });

    window.location.href='https://'+SHOP.domain+'/cart/'+partes.join(',');

  });



  /* --- Cualquier botón "Agregar al carrito" de la página --- */

  document.addEventListener('click',function(e){

    var b=e.target.closest('.add'); if(!b) return;

    var host=b.closest('[data-name]');

    if(!host) return;                                  // sin datos: lo maneja su propio script

    e.preventDefault();

    add({ talla:host.dataset.talla||'100', name:host.dataset.name, price:+host.dataset.price||449,

          img:host.dataset.img||'', sub:host.dataset.sub||'' });

    var t=b.textContent; b.textContent='Agregado ✓';

    setTimeout(function(){ b.textContent=t; },1400);

  });



  /* 3-sep: la promocion del frasco de bolsillo quita y pone renglones de regalo
     desde fuera. Antes lo hacia escribiendo el almacenamiento, pero este modulo
     guarda su propia lista en memoria y la volvia a escribir encima: al pulsar
     «cambiar» el regalo viejo seguia en pantalla y el nuevo se sumaba. Ahora el
     carrito se recarga desde el almacenamiento cuando se lo piden. */
  function recargar(){ items = leerCarritoSeguro(); render(); }
  function quitar(pred){ items = items.filter(function(it){ return !pred(it); }); render(); }
  window.VelantisCart={ add:add, open:open, close:close, recargar:recargar, quitar:quitar };

  render();

})();



/* ===== Aparición suave al hacer scroll (estilo Apple) ===== */

(function(){

  if(!('IntersectionObserver' in window)) return;

  var io=new IntersectionObserver(function(es){

    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });

  },{threshold:.1, rootMargin:'0px 0px -6% 0px'});

  var sel='.sec-head, #bestsellers .card, #nuevos .card, .season .card, .rev, .values .vg>div, .story .plate, .story .wrap>div:last-child';

  document.querySelectorAll(sel).forEach(function(el,i){

    el.classList.add('rv');

    el.style.transitionDelay=((i%4)*0.08)+'s';

    io.observe(el);

  });

})();

